import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const GuestToastStack = ({ items, onDismiss }) => {
  if (!items.length) {
    return null;
  }

  return (
    <ToastContainer position="top-center" className="p-3">
      {items.map((item) => (
        <Toast
          key={item.id}
          bg={item.variant}
          onClose={() => onDismiss(item.id)}
          autohide={item.autohide}
          delay={item.delay}
        >
          <Toast.Header closeButton>
            <strong className="me-auto">{item.title}</strong>
          </Toast.Header>
          <Toast.Body className={item.variant === "danger" || item.variant === "warning" ? "text-dark" : "text-white"}>
            <div style={{ whiteSpace: "pre-wrap" }}>{item.message}</div>
          </Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
};

export default GuestToastStack;
